import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.scss']
})
export class AddRoleComponent implements OnInit {
  usernameaddrole: any;
  lastNameAddrole: any;
  staffaddrole: string = "1";
  rolesetsucess: boolean = false;
  clickedrole: boolean = false;
  rolesetfail: boolean = false;
  errormsgaddrole: boolean = false;
  manageUserType: any = [];
  apierrormsg: boolean = false;
  detailstable: boolean = false;
  getaddroleuserdetaildata: any = [];
  userfullname: any;
  surname: any;
  email: any;
  unameAddrole: any;
  uType: any;
  countrycode: any;
  getaddroleavail: string[] = [];
  getaddroleselect: string[] = [];
  language: any = '';
  //settingadmin: boolean = false;
  userselectaddrole: string[] = [];
  useravailAddrole: string[] = [];
  constructor(private service: ApifirstService,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getAddAdminUserRoles(); 
  }
  getAddAdminUserRoles() {
    this.service.getAddAdminRoles().subscribe(
      (data) => {
        this.manageUserType = data.userRolesAvailableList
      })
  }
  getUseraddroleDetails() {
    this.apierrormsg=false;
    if ((this.usernameaddrole == null || this.usernameaddrole == undefined || this.usernameaddrole == '') &&
      (this.lastNameAddrole == null || this.lastNameAddrole == undefined || this.lastNameAddrole == '')) {
      this.errormsgaddrole = true;
      this.detailstable = false;
    }
    else {
      if (this.usernameaddrole == null) { this.usernameaddrole = '' }
      if (this.lastNameAddrole == null) { this.lastNameAddrole = '' }
      if (this.staffaddrole == null) { this.staffaddrole = "0" }
      this.errormsgaddrole = false;
      let manageuserdetail = {
        "username": this.usernameaddrole,
        "lastName": this.lastNameAddrole,
        "userType": this.staffaddrole
      }
      this.service.searchUserDetails(manageuserdetail).subscribe((datasearchUserDetails) => {
        this.getaddroleuserdetaildata = datasearchUserDetails;
        if(datasearchUserDetails.length == 0){
          this.apierrormsg = true;
          this.detailstable = false;
        }
        else
        {
          this.apierrormsg = false;
          this.detailstable = true;
        }
      }, (error) => {
        this.apierrormsg = true;
        this.detailstable = false;
      })
    }
  }
  /*functions to do required operations*/
  closeaddroletabs() {
    this.errormsgaddrole = false;
    this.staffaddrole = "1"
    this.userfullname = ''
    this.surname = ''
    this.email = ''
    this.unameAddrole = ''
    this.uType = ''
    this.countrycode = ''
    this.apierrormsg = false;
    this.getaddroleuserdetaildata = []
    this.usernameaddrole = ''
    this.lastNameAddrole = ''
    this.rolesetsucess=false;
    this.rolesetfail=false;
    this.detailstable=false;
    this.clickedrole=false;
  }
  getAddUserRoleDetails(usename: string, usertype: string, user:string,surname: string,
    email: string, countrycode: string, language: string) {
   // this.showhideblock1 = false
    this.userfullname = user
    this.surname = surname
    this.email = email
    this.unameAddrole = usename
    this.uType = usertype
    this.countrycode = countrycode
    this.language = language
    //this.settingadmin = true;
  }
  selectAddRoleUser(setadminrole:any) {
    this.rolesetsucess=false;
    this.rolesetfail=false;
    let getselectuserdetails =
    {
      "username": this.unameAddrole,
      "userType": this.uType
    }
    this.service.getUserRoleDetails(getselectuserdetails).subscribe(
      (datagetUserRoleDetails) => {
        this.getaddroleavail = datagetUserRoleDetails.availableUserRoles
        this.getaddroleselect = datagetUserRoleDetails.selectedUserRoles
      })
      this.modalService.open(setadminrole, { centered: true });
  }
  addRoleAdd() {
    this.rolesetsucess=false;
    this.rolesetfail=false;
    this.clickedrole=true;
    let user = this.useravailAddrole.map((user) => user);
    this.getaddroleavail = this.getaddroleavail.filter((value) => {
      return user.indexOf(value) === -1;
    })
    for (let usr of this.useravailAddrole) {
      if (!this.getaddroleselect.includes(usr)){
      this.getaddroleselect.push(usr);
      }
    }
    this.useravailAddrole =[];
  }
  removeAddRole() {
    this.rolesetsucess=false;
    this.rolesetfail=false;
    this.clickedrole=true;
    let users = this.userselectaddrole.map((users) => users);
    this.getaddroleselect = this.getaddroleselect.filter((value) => {
      return users.indexOf(value) === -1;
    })
    for (let usr of this.userselectaddrole) {
      if (!this.getaddroleavail.includes(usr)){
      this.getaddroleavail.push(usr);
      }
    }
    this.userselectaddrole=[];
  }
  setAddRoleUserRoleDetails() {
    let setuserdetails = {
      "username": this.unameAddrole,
      "userType": this.uType,
      "availableUserRoles": this.getaddroleavail,
      "selectedUserRoles": this.getaddroleselect
    }
    this.service.setUserRoleDetails(setuserdetails).subscribe(
      (datagetUserRoleDetails) => {
        this.getaddroleavail = datagetUserRoleDetails.availableUserRoles;
        this.getaddroleselect = datagetUserRoleDetails.selectedUserRoles;
        if(this.clickedrole){
        this.rolesetsucess=true;
        this.clickedrole=false;
        }
        else{
          this.rolesetsucess=false;
        }
        this.rolesetfail=false;
      }, (error) => {
        this.rolesetsucess = false;
        this.rolesetfail=true;
      })
  }

}
